export const Chevron = ({ className }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons ">
                <path id="Vector" d="M4.94543 2.94663C4.57288 3.31919 4.57288 3.921 4.94543 4.29355L8.65183 7.99995L4.94543 11.7064C4.57288 12.0789 4.57288 12.6807 4.94543 13.0533C5.31798 13.4258 5.91979 13.4258 6.29234 13.0533L10.677 8.66863C11.0495 8.29608 11.0495 7.69427 10.677 7.32172L6.29234 2.93708C5.92934 2.57408 5.31798 2.57408 4.94543 2.94663Z" fill="#1F1F1F" />
            </g>
        </svg>

    )
}

